/**
 * Runtime side of the release-identity contract.
 *
 * The build script stamps every production bundle with a content-derived
 * release id: a <meta name="prospero-release"> tag in index.html and a
 * /build.json file served no-store by the same nginx that serves the bundle.
 * A long-lived tab compares its own (in-DOM) release with the server's to
 * detect that a new frontend has been deployed. Build-time helpers live in
 * ./release-id.ts (never imported by browser code paths that ship node deps).
 */

export const RELEASE_META_NAME = 'prospero-release';
export const BUILD_JSON_PATH = '/build.json';

export function getLocalRelease(doc: Document = document): string | null {
  const content = doc.querySelector(`meta[name="${RELEASE_META_NAME}"]`)?.getAttribute('content');
  return content && content.length > 0 ? content : null;
}

export async function fetchServerRelease(fetchFn: typeof fetch = fetch): Promise<string | null> {
  try {
    const response = await fetchFn(BUILD_JSON_PATH, { cache: 'no-store' });
    if (!response.ok) {
      return null;
    }
    const data = (await response.json()) as { release?: unknown };
    return typeof data.release === 'string' && data.release.length > 0 ? data.release : null;
  } catch {
    return null;
  }
}
